module.exports = "<span class=\"icon-circle circle-blue\"></span>\n"